/* THREE65 (Oct 2026): cart drawer add-ons, loaded on every page.
   Adds the pair from the cart drawer offer and refreshes the drawer the way Stretch does after an add. */
(function () {
  'use strict';
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  function bundledSections() {
    var set = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: set } }));
    return Array.from(set);
  }

  async function addToCart(items, baseEvent) {
    var res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: bundledSections().join(',') })
    });
    var json = {};
    try { json = await res.json(); } catch (e) {}
    if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart. Please try again.');
    var cart = await (await fetch(root() + 'cart.js')).json();
    cart.sections = json.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: baseEvent, cart: cart } }));
    return cart;
  }

  window.THREE65 = window.THREE65 || {};
  window.THREE65.addToCart = addToCart;

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest ? e.target.closest('[data-t65-upsell-add]') : null;
    if (!btn) return;
    var box = btn.closest('[data-t65-upsell]');
    var select = box.querySelector('[data-t65-upsell-size]');
    var msg = box.querySelector('[data-t65-upsell-msg]');
    if (!msg.hasAttribute('data-default')) msg.setAttribute('data-default', msg.textContent);
    if (!select.value) {
      msg.textContent = msg.getAttribute('data-default');
      msg.hidden = false;
      select.focus();
      return;
    }
    msg.hidden = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      await addToCart([{ id: Number(select.value), quantity: 1 }], 't65:upsell');
      setTimeout(function () {
        var checkout = document.querySelector('cart-drawer button[name="checkout"]');
        if (checkout) checkout.focus();
      }, 50);
    } catch (err) {
      msg.textContent = err.message;
      msg.hidden = false;
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-t65-upsell-size]')) {
      var msg = e.target.closest('[data-t65-upsell]').querySelector('[data-t65-upsell-msg]');
      if (msg) msg.hidden = true;
    }
  });
})();
